/**
 * Remembers the last dashboard page the user could actually open, so a page
 * they're not allowed on can send them straight back there instead of a dead
 * end.
 *
 * - DashBoardLayout calls rememberPath() on every navigation.
 * - A page that refuses the user calls markDenied() while rendering — before
 *   the layout's effect runs — so a denied page is never remembered and the
 *   redirect can't loop.
 *
 * sessionStorage keeps it across reloads in this tab only; every access is
 * guarded because storage can be unavailable (private mode, blocked).
 */
export const DASHBOARD_HOME = "/admin/dashboard";
const KEY = "uniedu:lastDashboardPath";
const denied = new Set();

const pathOnly = (p) => (p || "").split("?")[0].replace(/\/+$/, "");

export const markDenied = (path) => {
  denied.add(pathOnly(path));
};

export const rememberPath = (path) => {
  if (!path || !path.startsWith(DASHBOARD_HOME) || denied.has(pathOnly(path))) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    /* storage unavailable — fall back to the dashboard home */
  }
};

/** Where to send someone who can't stay on `current`. */
export const lastAllowedPath = (current) => {
  let last = null;
  try {
    last = sessionStorage.getItem(KEY);
  } catch {
    last = null;
  }
  const bad = !last || denied.has(pathOnly(last)) || pathOnly(last) === pathOnly(current);
  return bad ? DASHBOARD_HOME : last;
};
